import { render, staticRenderFns } from "./MemberCollect.vue?vue&type=template&id=3bd3cee4&scoped=true&"
import script from "./MemberCollect.vue?vue&type=script&lang=js&"
export * from "./MemberCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3cee4",
  null
  
)

export default component.exports